var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FlexSection from '@marketing/components/sections/FlexSection';
import { clsx } from 'clsx';
import Image from '../../Media/Image';
import ReviewsCarousel from './Carousel';
function ReviewsSection(_a) {
    var content = _a.content, _b = _a.theme, theme = _b === void 0 ? 'light' : _b, _c = _a.backgroundColorStyle, backgroundColorStyle = _c === void 0 ? 'bg-deco-pink' : _c;
    var reviews = content.reviews, heroImage = content.heroImage;
    // a hack to give desktop a margin:auto on the left, but not on the right,
    // since cards need to be visible in the overflow of their container to the
    // far right edge, but be overflow:hidden to the left of their container,
    // so that the cards don't overlap the heading, etc.
    var desktopLeftMarginClassName = 'md:ml-[max(0px, (100vw-1440px)/2)]';
    return (_jsxs(FlexSection, __assign({ backgroundColorStyle: backgroundColorStyle, className: clsx(desktopLeftMarginClassName, 'w-auto'), paddingStyle: "pl-2xs-gutter pt-sm-gutter md:pl-3xl-gutter md:pt-sm-gutter md:pr-0", gapStyle: "md:gap-xl-m" }, { children: [_jsx("div", __assign({ className: "w-full md:w-[328px] shrink-0 overflow-hidden pr-2xs-gutter md:pr-0" }, { children: _jsx(ReviewsCarousel, { reviews: reviews, theme: theme }) })), _jsx("div", __assign({ className: "w-full flex-1 flex justify-end" }, { children: _jsx(Image, { imageData: heroImage, className: "md:!w-[694px] md:!h-[452px] !rounded-none" }) }))] })));
}
export default ReviewsSection;
